import { Helper } from "../util/helper.js";
import { General } from "../../../siteManagement/general.js";
import { SheetEventType } from "../../../siteManagement/sheet.js";
import { Config } from "../config/config.js";
import { BaseComponentProps, BaseField } from "./baseComponentProps.js";
import { CommandManagerAPI, StringKeyDictionary } from "../../commonInterfaces.js";
import * as statisticUi from "../../statistics/statistic_ui.js"
import * as componentRegistrar from "../../statistics/components_registrar.js"
import React from "react";
import {Commands} from "../util/commandManager";

export class Statistic extends React.Component<StatisticProps, any>{
    private _icuh = Helper;
    private _parameters: StringKeyDictionary<string> = {};
    private _hasParams = false;
    private _guid = kendo.guid();
    private static _componentRegistrar;
    private unmounted: boolean = false;

    constructor(props: StatisticProps) {
        super(props);
        this.refreshParams(props);
    }

    private _setEvents() {
        if (!Statistic._componentRegistrar) {
            componentRegistrar.registerComponents();
            Statistic._componentRegistrar = componentRegistrar;
        }
        if (!this.unmounted) {
            this.setState({ statisticUi: statisticUi, componentRegistrar: componentRegistrar });
        }

        const sheet = General.Sheet.Manager.getTopMostVisibleSheet();
        if (sheet !== null) {
            sheet.bind(SheetEventType.SavedSuccessfully, (target) => {
                // GUID nach jedem Speichern ändern, damit die Statistik sich refresht
                this._guid = kendo.guid();
            });
        }
        
        if (this.props.commandManager) {
            this.props.commandManager.registerExecutor("updateStaticGuid", (command, data) => {
                if (command === Commands.REFRESH) {
                   // debugger;
                    this._guid = kendo.guid();
                }
            });
        }
    }
    componentDidMount() {
        this._setEvents();
    }

    private _getParamValues = (): StringKeyDictionary<string> => {
        if (this._hasParams) {
            const params: StringKeyDictionary<string> = {};
            for (let key in this.props.field.parameters) {
                if (typeof this.props.field.parameters[key] == "string") {
                    params[key] = this.props.handleEval(this.props.field.parameters[key]);
                }
                else {
                    params[key] = this.props.field.parameters[key];
                }

            }
            params["__GUID"] = this._guid;
            return params;
        }
        return null;
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        this.refreshParams(newProps);
    }

    private refreshParams(props: StatisticProps) {
        if (this._icuh.hasValue(props.field.parameters) && Object.keys(props.field.parameters).length > 0) {
            this._hasParams = true;
            this._parameters = this._getParamValues();
        }
    }

    componentWillUnmount() {
        this.unmounted = true;
    }

    render() {
        const configObject = {
            basePath: Config.baseUrl,
            statisticId: this.props.field.statisticId,
            params: this._getParamValues()
        }
        const className = this.props.fullHeightLayout ? "flex-container" : "";
        return (
            <div className={className}>{this.state && this.state.statisticUi ? this.state.statisticUi.renderDrillDownStatistic(configObject) : "Loading..."}</div>
        );
    }
};

export interface StatisticProps extends BaseComponentProps {
    field: StatisticField;
    handleEval?(action: string, prepare?: any);
    fullHeightLayout?: boolean;
    commandManager?: CommandManagerAPI;
}

export interface StatisticField extends BaseField {
    statisticId: string;
    parameters: StringKeyDictionary<any>;
}